import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectModule } from '../../select/select.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { WtdPickerComponent } from './wtd-picker.component';
import { TextfieldComponent } from '../../textfield/textfield.component';
import { RichtextareaComponent } from '../../richtextarea/richtextarea.component';
import { ContentPickerModule } from '../../content-picker/content-picker.module';
import { WtdContentPickerModule } from './wtd-content-picker/wtd-content-picker.module';

@NgModule({
    declarations: [
        WtdPickerComponent,
    ],
    imports: [
        CommonModule,
        SelectModule,
        SharedModule,
        TextfieldComponent,
        RichtextareaComponent,
        ContentPickerModule,
        WtdContentPickerModule,
    ],
    exports: [
        WtdPickerComponent,
    ]
})
export class WtdPickerModule { }